import { render, staticRenderFns } from "./product-suggest.vue?vue&type=template&id=64b1a931&"
import script from "./product-suggest.vue?vue&type=script&lang=js&"
export * from "./product-suggest.vue?vue&type=script&lang=js&"
import style0 from "./product-suggest.vue?vue&type=style&index=0&id=64b1a931&prod&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports